export default __webpack_public_path__ + "static/media/searchButton.903f7e5e.svg";